import { signal } from 'services/SignalsService'

export default class ModeModel {
  constructor() {
    this._auto = false
    this._buyFeature = false
    this._respinIntro = false

    this.createSignal()
  }

  createSignal() {
    signal.on('RADIO:ui', (value) => this.auto = value)
  }

  set auto(value) {
    this._auto = value == 'automenu'
  }

  get auto() {
    return this._auto
  }

  set respinIntro(value) {
    this._respinIntro = value
  }

  get respinIntro() {
    return  this._respinIntro
  }

  set buyFeature(value) {
    this._buyFeature = value
  }

  get buyFeature() {
    return this._buyFeature
  }

  get turbo() {
    return 'turbo'
  }
}
